import React, {
  FocusEvent,
} from 'react';
import clsx from 'clsx';
import MaskedTextField from 'core/components/MaskedTextField';
import type {
  MaskedInputValue,
} from 'core/components/formValue';

const mask = [{
  mask: '00000',
  lazy: true,
  overwrite: 'shift' as const,
},
{
  mask: '00000-0000',
  lazy: true,
  overwrite: 'shift' as const,
}];

type Props = {
  id?: string;
  disabled?: boolean;
  value?: MaskedInputValue;
  onChange: (value: string | number | null) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  className?: string;
  inputProps?: object;
  isLongZipRequired?: boolean;
  showErrorText?: boolean;
};

export default function ZipCodeTextField({
  value,
  className,
  onChange,
  onFocus,
  isLongZipRequired = false,
  showErrorText,
  ...props
}: Props) {
  const zipCodeMask = isLongZipRequired ? mask.slice(1) : mask;
  return (
    <MaskedTextField
      {...props}
      mask={zipCodeMask}
      value={value ?? ''}
      placeholder="Zip Code"
      onAccept={onChange}
      showErrorText={showErrorText}
      className={clsx('populate-input populate-zipcode-input bg-white', className)}
    />
  );
}
